import request from "src/api/request-manager/gateway";
import {
  GetVerificationsResponse,
  CheckIdentityOCRData,
  CheckIdentityOCRResponse,
  CheckLivenessData,
  CheckLivenessResponse,
  SetDocumentData,
  SetDocumentResponse
} from "./types/verifications.types";

const prefixURL = "/dashboard/v1";

const customHead = { "content-type": "multipart/form-data" };

const VerificationsAPI = {
  getVerifications(): Promise<GetVerificationsResponse> {
    return request.get<GetVerificationsResponse>(`${prefixURL}/verifications`);
  },
  checkIdentityOCR(data: CheckIdentityOCRData): Promise<CheckIdentityOCRResponse> {
    return request.post<CheckIdentityOCRResponse>(`${prefixURL}/verifications/check-ocr`, data);
  },
  checkLiveness(data: CheckLivenessData): Promise<CheckLivenessResponse> {
    return request.post<CheckLivenessResponse>(`${prefixURL}/verifications/check-liveness`, data);
  },
  setDocument(data: SetDocumentData): Promise<SetDocumentResponse> {
    return request.post<SetDocumentResponse>(`${prefixURL}/verifications/set-document`, data, customHead);
  }
};

export default VerificationsAPI;
